module.exports = __webpack_public_path__ + "img/Weapon_100.ea58a7dd.png";